import { TennisResultsCategoriesProps } from "@sky-it-livedata/livedata-sports-design-system";
import { CreateResultsCategoriesWidgetInputSchema } from "cdk/graphql";
import { ResultsCategoriesData } from "../types";
import {
  cagetoriesMapGranSlam,
  categoriesMap,
} from "../../../utils/categoriesMap";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { isValidResultsCategories } from "./typeguards";


type Categories = TennisResultsCategoriesProps["categories"];
type Adv = TennisResultsCategoriesProps["adv"];

const getCategoryName = (name: string, tournamentType?: string) => {
  if (tournamentType === "GrandSlam") {
    return (
      cagetoriesMapGranSlam[name as keyof typeof cagetoriesMapGranSlam] || name
    );
  }
  return categoriesMap[name as keyof typeof categoriesMap] || name;
}

export const transformer = (
  obj: ResultsCategoriesData
): TennisResultsCategoriesProps => {
  if (isValidResultsCategories(obj)) {
    CreateResultsCategoriesWidgetInputSchema().parse(obj.data.getResultsCategoriesWidget, {reportInput: true});
    const widget = obj?.data?.getResultsCategoriesWidget!;
    const categories = (widget?.categories || []) as Categories;
    const { link, image } = widget?.adv || {};
    return {
      adv: link ? ({ link, image } as Adv) : undefined,
      targetSelector: "ld-tennis-results",
      categories: categories?.map((category) => ({
        ...category,
        name: category.name,
        label: getCategoryName(category.name, widget.type!),
      })),
      initialIndex: 0,
      setDefaultIndex: () => { },
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in ResultsCategories object',
      data: obj
    });
  }
};
